import { gql, useQuery } from '@apollo/client';

const GET_PROGRAM_BY_ID = gql`
query FetchProgramById($id: Uuid!) {
  programsById(id: $id) {
    about
    achievements
    description
    duration
    durationMetric
    inviteOnly
    name
    id
    organisationId
    price
    published
    programCoursesAggregate {
      agg_count
    }
    image
    programCourses {
      course{
        openedxCourseId
      }
    }
  }
}
`;

const useFetchProgramById = (id) => {
  const { data, loading, error, refetch } = useQuery(GET_PROGRAM_BY_ID, {
    context: {
      headers: {
        'x-hasura-role': 'learner',
      },
    },
    variables: { id },
    skip: !id,
  });

  return {
    data: data?.programsById,
    loading,
    error,
    refetch,
  };
};

export default useFetchProgramById;
